import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSanfranciscomunicipalrailwayComponent } from './simple-icons-sanfranciscomunicipalrailway.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSanfranciscomunicipalrailwayComponent ],
    exports:      [ SimpleIconsSanfranciscomunicipalrailwayComponent ],
    bootstrap:    []
})
export class SimpleIconsSanfranciscomunicipalrailwayModule {}
